import $ from 'jquery';
const toggleCollapse = (e, sel)=>{
	const $target = $(sel);
	if ($target.length!=1){
		return;
	}
	if (e){
		e.preventDefault();
		e.stopPropagation();
	}
	const $togglers = $('[href="'+sel+'"]');
	if ($target.hasClass('active')){
		$target.removeClass('active');
		$target.slideUp();
		$togglers.attr('aria-expanded', 'false').removeClass('active');
	}
	else{
		$target.slideDown();
		$target.addClass('active');
		$togglers.attr('aria-expanded', 'true').addClass('active');
	}
}

$(document).on('click', '[data-wf-toggle="collapse"]', function(e){
	const href = $(this).attr('href');
	toggleCollapse(e, href);
});

